/**
 * Markdown component that renders markdown (including streaming deltas) using
 * the vendored streaming-markdown parser (lib/smd.js).
 *
 * On each text change the container is cleared and the full text is fed through
 * a fresh parser instance, mirroring how the original DOM-based renderer
 * refreshed streaming content. This keeps each render correct and lets the
 * bubble grow progressively as deltas arrive.
 */
import { useEffect, useRef } from 'preact/hooks';
import { parser, parser_write, parser_end, default_renderer } from '../lib/smd.js';

export function Markdown({ text, className = '' }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;
    ref.current.innerHTML = '';
    const full = text ?? '';
    if (!full) return;
    const renderer = default_renderer(ref.current);
    const p = parser(renderer);
    try {
      parser_write(p, full);
      parser_end(p);
    } catch {
      /* ignore */
    }
  }, [text]);

  // eslint-disable-next-line react/no-unknown-property
  return <div ref={ref} className={className} />;
}